// Selector for the live chat launcher. Empty = no chat hiding.
// Gorgias was '#gorgias-chat-container'; fill in Richpanel's equivalent to re-enable.
const CHAT_LAUNCHER = '';
function hideChatLauncher(hide) {
  if (!CHAT_LAUNCHER) return;
  const el = document.querySelector(CHAT_LAUNCHER);
  if (el) el.style.display = hide ? 'none' : '';
}

class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartItems = document.querySelector('cart-items');
      this.miniCart = document.getElementById('mini-cart');
      this.atc_button = this.querySelector('.product-form__atc');
      this.variant_selectors_cntr = document.querySelector('variant-radios');
      this.variant_selectors = document.querySelector('variant-radios fieldset');
      this.variant_selectors_height = this.variant_selectors.clientHeight;
      this.top_position = this.offsetTop;
      this.form_height = this.clientHeight;
      this.variant_toggle = this.variant_selectors_cntr.querySelector('legend');

      document.addEventListener('scroll', this.stickyScroll.bind(this));

      this.variant_toggle.addEventListener('click', (e) => {
        this.variant_selectors.classList.toggle('make-selection');
      });
    }

    stickyScroll() {
      if (window.innerWidth < 990) {
        if (window.scrollY > (this.top_position + this.form_height + 70)) {
          this.style.height = this.form_height + 'px';
          this.atc_button.classList.add('stuck');
          this.variant_selectors_cntr.style.height = this.variant_selectors_height + 'px';
          this.variant_selectors.classList.add('stuck');
          this.variant_selectors.style.bottom = this.form_height + 'px';
          // Gorgias is uninstalled and this element no longer exists, so the old
          // unguarded call threw a TypeError on every sticky-bar toggle. Left null-safe
          // rather than deleted: to restore the hide-chat-behind-sticky-ATC behaviour,
          // put Richpanel's launcher selector in CHAT_LAUNCHER below.
          hideChatLauncher(true);
        } else {
          this.style.height = '';
          this.atc_button.classList.remove('stuck');
          this.variant_selectors_cntr.style.height = '';
          this.variant_selectors.style.bottom = '';
          this.variant_selectors.classList.remove('stuck');
          hideChatLauncher(false);
        }
      }
    }

    vanillaSerialize (data) {
      let obj = {};
      for (let [key, value] of data) {
        if (obj[key] !== undefined) {
          if (!Array.isArray(obj[key])) {
            obj[key] = [obj[key]];
          }
          obj[key].push(value);
        } else {
          obj[key] = value;
        }
      }
      return obj;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      const formData = new FormData(this.form);
      let lineItemMessage = '';

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      let itemsArr = [];
      const prodID = this.form.querySelector('input[name="id"]').value;
      const preorderMessages = document.getElementsByClassName('preorder-message');
      for (let i = 0; i < preorderMessages.length; i++) {
        if(preorderMessages[i].classList.contains('active')){
          lineItemMessage = preorderMessages[i].textContent.trim();
        }
      }

      const itemProperties = {};
      if (lineItemMessage) itemProperties["Delivery"] = lineItemMessage;
      if (this.dataset.isRewearProduct) itemProperties["Product type"] = 'Re-wear';

      itemsArr.push({
        id: prodID,
        quantity: 1,
        properties: itemProperties
      });

      const body = JSON.stringify({
        items: itemsArr,
        sections: this.cartItems.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
      const miniCart = document.getElementById('mini-cart');
      miniCart.classList.add('just-added');
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            document.querySelector('.mini-cart-add-error').classList.remove('hidden');
            this.miniCart?.open(true);
          } else {
            document.querySelector('.mini-cart-add-error').classList.add('hidden');
            this.cartItems.renderContents(parsedState);
            return this.cartItems.checkGifts();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {

          setTimeout(() => {
            miniCart.classList.remove('just-added');
          }, 2000);
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  customElements.define('product-form', ProductForm);
